export enum AuthenticationType {
  Password = 0,
  Sso = 1,
  UserApi = 2,
  Passwordless = 3,
  Biometrics = 4,
  Google = 5,
}
